import axios from '__js__/axios';
import reverse from 'django-reverse';
import {AxiosResponse} from 'axios';
import {URLS} from './URLS';

export default async (mapTranslate_id): Promise<AxiosResponse> => {
  return await axios.post(reverse(URLS.QUICK_EXERCISE, mapTranslate_id));
}
